<template>
  <div
    class="c-table-cell"
    :class="{
      'c-table__cell__red': data.fineOrBonusFullNameCell.isRedCell,
      'c-table__cell__blue': data.fineOrBonusFullNameCell.isBlueCell,
      'c-table__cell__white': !data.fineOrBonusFullNameCell.isRedCell && !data.fineOrBonusFullNameCell.isBlueCell,
    }"
  >
    <div class="c-table__cell-value">
      <a :href="linkToWorker" target="_blank">
        {{ data.fineOrBonusFullNameCell.workerName }}
      </a>
    </div>
  </div>
</template>

<script>
import { FINE_GROUP_ALT } from "@/constants/fineAndBonusGroups";

export default {
  name: "full-name-cell",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    linkToWorker() {
      const measure = this.data.fineOrBonusFullNameCell.type === FINE_GROUP_ALT ? "fines" : "bonuses";
      const routeData = this.$router.resolve({
        path: `/personal-employee/${this.data.fineOrBonusFullNameCell.workerId}/discipline?measure=${measure}&sortBy=date_timestamp&sortType=desc`,
      });

      return routeData.href;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-table__cell {
  display: flex;
  &-value {
    height: 100%;
    display: flex;
    align-items: center;
  }
  &__red {
    background-color: #ffe6f2;
  }
  &__blue {
    background-color: #e1edff;
  }
  &__white {
    background-color: #fff;
  }
  &__icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15px;
    margin-right: 12px;
  }
}
</style>
